var map = {
	"./locales/cs/translation.json": 62676,
	"./locales/de/translation.json": 81549,
	"./locales/en/translation.json": 44985,
	"./locales/en_devel/translation.json": 36740,
	"./locales/es/translation.json": 45386,
	"./locales/et/translation.json": 58207,
	"./locales/fi/translation.json": 97171,
	"./locales/fr/translation.json": 75842,
	"./locales/it/translation.json": 84051,
	"./locales/nl/translation.json": 90348,
	"./locales/ssd/translation.json": 37856,
	"./locales/zh_Hans/translation.json": 97021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83212;